/**
 * @generated SignedSource<<4d434195016825403cecc5d273d297ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UsersPageCapabilitiesQuery$variables = {
  email?: string | null;
};
export type UsersPageCapabilitiesQuery$data = {
  readonly adminCapabilities: ReadonlyArray<{
    readonly id: string;
    readonly slug: string;
  }>;
  readonly restaurantCapabilities: ReadonlyArray<{
    readonly defaultValue: string;
    readonly name: string;
    readonly overrideReason: string | null;
    readonly overrideValue: string | null;
    readonly plan: string | null;
    readonly planValue: string | null;
    readonly resolvedValue: string;
    readonly slug: string;
    readonly source: string;
    readonly type: string;
  }>;
};
export type UsersPageCapabilitiesQuery = {
  response: UsersPageCapabilitiesQuery$data;
  variables: UsersPageCapabilitiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "RestaurantCapabilityValue",
    "kind": "LinkedField",
    "name": "restaurantCapabilities",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "overrideValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "overrideReason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resolvedValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "source",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "plan",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Capability",
    "kind": "LinkedField",
    "name": "adminCapabilities",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      (v1/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UsersPageCapabilitiesQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UsersPageCapabilitiesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c7be1a6dd913125d2b76b2b2c3d5e2eb",
    "id": null,
    "metadata": {},
    "name": "UsersPageCapabilitiesQuery",
    "operationKind": "query",
    "text": "query UsersPageCapabilitiesQuery(\n  $email: String\n) {\n  restaurantCapabilities(email: $email) {\n    slug\n    name\n    type\n    defaultValue\n    planValue\n    overrideValue\n    overrideReason\n    resolvedValue\n    source\n    plan\n  }\n  adminCapabilities {\n    id\n    slug\n  }\n}\n"
  }
};
})();

(node as any).hash = "eae69c981e838ca9f07ba79a669a34ca";

export default node;
